/**
 * ログ一覧ヘッダーコンポーネント
 *
 * タイトル、更新ボタン、条件クリアボタンを表示
 */

import { Group, Title, Button, Loader } from "@mantine/core";
import { FileText, X, RotateCw } from "lucide-react";

interface LogsListHeaderProps {
  loading: boolean;
  hasActiveFilters: boolean;
  onRefresh: () => void;
  onResetFilters: () => void;
}

/**
 * ログ一覧ヘッダー
 */
export function LogsListHeader({
  loading,
  hasActiveFilters,
  onRefresh,
  onResetFilters,
}: LogsListHeaderProps) {
  return (
    <Group justify="space-between" wrap="nowrap">
      <Group gap="sm">
        <FileText size={20} />
        <Title order={4}>イベントログ</Title>
        <Button
          variant="subtle"
          color="gray"
          size="compact-xs"
          onClick={onRefresh}
          disabled={loading}
          leftSection={loading ? <Loader size={14} color="gray" /> : <RotateCw size={14} />}
          aria-label="ログを更新"
        >
          更新
        </Button>
      </Group>

      <Button
        variant={hasActiveFilters ? "light" : "subtle"}
        color={hasActiveFilters ? "red" : "gray"}
        size="compact-xs"
        onClick={onResetFilters}
        disabled={!hasActiveFilters}
        leftSection={<X size={14} />}
      >
        条件クリア
      </Button>
    </Group>
  );
}
